import CheckCircle from "@assets/images/check-circle.svg";
import { Box, Button, Dialog, Typography } from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useState
} from "react";
import { useIntl } from "react-intl";

const useStyle = makeStyles(
  () => ({
    dialog: {
      maxWidth: "80vw",
      maxHeight: "80vh",
      overflowY: "auto",
      padding: "32px 24px 32px 24px",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      borderRadius: "16px"
    },
    modalBg: {
      borderRadius: "16px"
    },
    title: {
      fontSize: "20px",
      fontWeight: 700
    },
    button: {
      alignSelf: "center",
      backgroundColor: "#009FB8",
      borderRadius: "4px",
      width: "100%",
      minHeight: "48px",
      fontSize: "18px"
    },
    buttonTitle: {
      fontSize: "18px",
      color: "white"
    },
    checkCircle: {
      height: "40px",
      width: "40px"
    },
    fileResult: {
      paddingTop: "8px",
      paddingBottom: "24px",
      fontSize: "20px",
      wordWrap: "break-word"
    }
  }),
  { name: "DialogSuccess" }
);

export interface IRefDialogSuccess {
  onOpen: (filename: string) => void;
  visible: boolean;
  onClose: () => void;
}

const DialogSuccess: ForwardRefRenderFunction<IRefDialogSuccess> = (
  _props,
  ref
) => {
  const classes = useStyle();
  const intl = useIntl();

  const [visible, setVisible] = useState<boolean>(false);
  const [filename, setFilename] = useState<string>();
  const onClose = () => setVisible(false);

  const onOpen = (e: string) => {
    setFilename(e);
    setVisible(true);
  };

  useImperativeHandle(ref, () => ({ onOpen, onClose, visible }));

  return (
    <Dialog
      open={visible}
      keepMounted
      onClose={onClose}
      className={classes.modalBg}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
    >
      <Box
        className={classes.dialog}
        display="flex"
        flexDirection={"column"}
        textAlign={"center"}
      >
        <Box>
          <img
            src={CheckCircle}
            alt="success"
            className={classes.checkCircle}
          />
        </Box>
        <Typography className={classes.fileResult}>
          {intl.formatMessage({
            defaultMessage: "อัปโหลดไฟล์ ",
            description: "file"
          })}
          <span style={{ wordWrap: "break-word" }}>{filename}</span>
          <br />
          <b>
            {intl.formatMessage({
              defaultMessage: "สำเร็จ",
              description: "file"
            })}
          </b>
        </Typography>

        <Button className={classes.button} onClick={onClose}>
          <Typography className={classes.buttonTitle}>
            {intl.formatMessage({
              defaultMessage: "ดำเนินการต่อ",
              description: "close"
            })}
          </Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default forwardRef(DialogSuccess);
